<div class="d-flex justify-content-center align-items-center mt-4 mb-3">
  <div class="d-flex align-items-center no-record default-color">
    <mat-icon class="mr-2">info</mat-icon>
    <i>{{ message }}</i>
  </div>
</div>
